import styles from './Promo.module.scss'

import React, { useEffect, useState } from 'react'

import GetTimeAgoString from 'Utilities/DateTime/TimeAgo'
import { getDaysUntil } from 'Utilities/DateUtilities/DateUtilities'

import Card from 'Atoms/Card'
import Typography from 'Atoms/Typography'

const Promo = ({ promo }) => {
  const [expired, setExpired] = useState(false)

  if (!promo || !promo.anythingToDisplay || expired) return false

  return (
    <Card isAccent intent={`positive`} noPadding className={styles.container} noMargin>
      <Expiration expiresOn={promo.expiresOn} setExpired={setExpired} />
    </Card>
  )
}

const Expiration = ({ expiresOn, setExpired }) => {
  const daysUntil = getDaysUntil(expiresOn)

  if (daysUntil > 14) {
    return (
      <Typography size={0.75} font={'bold'}>
        Promotions Available
      </Typography>
    )
  }

  if (daysUntil > 2) {
    const text = `expires ${GetTimeAgoString(expiresOn)}`
    return (
      <Typography size={0.75} intent={'warning'} font={'bold'}>
        <Typography size={0.75} font={'bold'} className={styles.inlineText}>
          Promotion{' '}
        </Typography>
        {text}
      </Typography>
    )
  }

  const expiresOnDate = new Date(expiresOn)
  return <CountDownExpiration expiresOnDate={expiresOnDate} setExpired={setExpired} />
}

const CountDownExpiration = ({ expiresOnDate, setExpired }) => {
  const [displayMessage, setDisplayMessage] = useState(null)

  const setMessage = () => {
    const milli = expiresOnDate - new Date()
    const seconds = Math.round(milli / 1000)

    const hours = Math.floor(seconds / 3600)
    const remainingSeconds = seconds % 3600
    const minutes = Math.floor(remainingSeconds / 60)

    const message = hours > 0 ? `${hours} hour${hours > 1 ? 's' : ''}` : `${minutes} minute${minutes > 1 ? 's' : ''}`

    if (hours <= 0 && minutes <= 0) {
      setExpired(true)
    }

    setDisplayMessage(message)
  }

  useEffect(() => {
    setMessage()
    setInterval(setMessage, 60000)
  }, [])

  const text = `expires in ${displayMessage}`
  return (
    <Typography size={0.75} intent={'warning'} font={'bold'}>
      <Typography size={0.75} font={'bold'} className={styles.inlineText}>
        Promotion{' '}
      </Typography>
      {displayMessage ? text : undefined}
    </Typography>
  )
}

export default Promo
